import { FeatureRoleList } from './FeatureRoleList'
import { withFeatureRoleList } from './withFeatureRoleList'

const ConnectedFeatureRoleList = withFeatureRoleList(FeatureRoleList)

export { ConnectedFeatureRoleList as FeatureRoleList }
